<header class="site-header" [class.scrolled]="isScrolled">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <a routerLink="/" class="logo-link" (click)="closeMenu()">
          <img src="assets/logo.png" alt="DirtRunner Logo" width="40" height="40" />
          <span class="logo-text"><span>Dirt</span>Runner</span>
        </a>
      </div>

      <div
        class="mobile-menu-toggle"
        [class.active]="isMenuOpen"
        (click)="toggleMenu()"
        (keydown.enter)="toggleMenu()"
        tabindex="0"
        role="button"
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav class="main-nav" [class.active]="isMenuOpen">
        <ul>
          <li>
            <a
              [class.active]="
                router.url === '/' && (activeSection() === 'home' || activeSection() === null)
              "
              (click)="scrollToTop()"
              (keydown.enter)="scrollToTop()"
              tabindex="0"
              role="button"
              >Home</a
            >
          </li>
          <li>
            <a
              [class.active]="router.url === '/' && activeSection() === 'features'"
              (click)="scrollToFragment('features')"
              (keydown.enter)="scrollToFragment('features')"
              tabindex="0"
              role="button"
              >Features</a
            >
          </li>
          <li>
            <a
              [class.active]="router.url === '/' && activeSection() === 'how-it-works'"
              (click)="scrollToFragment('how-it-works')"
              (keydown.enter)="scrollToFragment('how-it-works')"
              tabindex="0"
              role="button"
              >How It Works</a
            >
          </li>
          <li>
            <a
              [routerLink]="ROUTES.ROLE_SELECTION"
              routerLinkActive="active"
              (click)="closeMenu()"
              class="nav-button primary"
              >Get Started</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
</header>

<div
  class="mobile-menu-overlay"
  [class.active]="isMenuOpen"
  (click)="closeMenu()"
  (keydown.enter)="closeMenu()"
  tabindex="-1"
  aria-hidden="true"
></div>
